/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ComponentFieldKey, ComponentData, ComponentModel } from '../model/component.model';
import { ViewComponentKey } from '../key/view-component.key';

export interface TableRowData extends ComponentData {
  index: number;
  format?: string;
  // alignment?: Alignment;
}

export class TableRowFieldKey {
  static readonly INDEX = 'index';
  static readonly FORMAT = 'format';
  // static readonly ALIGNMENT = 'alignment';
}

export class TableRowModel extends ComponentModel implements TableRowData {
  static readonly KEYS = ComponentModel.KEYS.concat(
    Object.keys(TableRowFieldKey).map((key) => TableRowFieldKey[key])
  );

  constructor(data?: TableRowData, keys?: string[]) {
    super(data, keys || TableRowModel.KEYS);
  }

  get index(): number {
    return this.get(TableRowFieldKey.INDEX);
  }

  get format(): string {
    return this.get(TableRowFieldKey.FORMAT);
  }

  set format(value: string) {
    this.set(TableRowFieldKey.FORMAT, value);
  }

  // get alignment(): Alignment {
  //   return this.get(TableRowFieldKey.ALIGNMENT);
  // }

  // set alignment(value: Alignment) {
  //   this.set(TableRowFieldKey.ALIGNMENT, value);
  // }

  protected setupValues(values: TableRowData, exclusive: boolean): TableRowData {
    if (exclusive && !(ComponentFieldKey.TYPE in values)) {
      values.type = ViewComponentKey.TABLE_ROW;
    }
    return super.setupValues(values, exclusive) as TableRowData;
  }

}
